import { render } from "./BookingBedBathSelector.vue?vue&type=template&id=f08b1f34"
import script from "./BookingBedBathSelector.vue?vue&type=script&lang=js"
export * from "./BookingBedBathSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__